import { Backpack, GraduationCap, ShieldCheck, Users, type LucideIcon } from 'lucide-react'
import type { Portal } from './types'

export interface PortalMeta {
  key: Portal
  label: string
  short: string
  description: string
  icon: LucideIcon
}

const ADMIN: PortalMeta = {
  key: 'admin',
  label: 'Administration',
  short: 'Admin',
  description: 'Management console for the school office',
  icon: ShieldCheck,
}

export const PORTALS: PortalMeta[] = [
  ADMIN,
  {
    key: 'staff',
    label: 'Staff & Teachers',
    short: 'Staff',
    description: 'Classes, timetable and your own records',
    icon: GraduationCap,
  },
  {
    key: 'family',
    label: 'Students & Guardians',
    short: 'Family',
    description: 'Profile, enrollment and school notices',
    icon: Users,
  },
]

/** Schools without guardians: the family portal is the students' portal. */
const STUDENTS_ONLY: PortalMeta = {
  key: 'family',
  label: 'Students',
  short: 'Students',
  description: 'Courses, results, timetable and school notices',
  icon: Backpack,
}

export function portalsFor(guardians: boolean): PortalMeta[] {
  return guardians ? PORTALS : PORTALS.map((p) => (p.key === 'family' ? STUDENTS_ONLY : p))
}

export function portalMeta(key: string | null | undefined, guardians = true): PortalMeta {
  return portalsFor(guardians).find((p) => p.key === key) ?? ADMIN
}
